<template>
  <div class="font-sans">
    <div class="fixed bottom-4 right-4">
      <transition
        enter-active-class="transition duration-300 ease-out"
        enter-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-150 ease-in"
        leave-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0"
      >
        <div
          v-if="is_shown"
          class="absolute bottom-0 right-0 z-20 ml-auto origin-bottom-right w-72"
        >
          <button
            @click="toggleVideo"
            class="absolute top-0 right-0 z-10 w-8 h-8 p-2 -mt-3 -mr-3 overflow-visible text-white bg-black rounded-full"
          >
            <svg fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </button>
          <div
            class="relative flex flex-col overflow-hidden rounded-lg shadow-lg"
          >
            <video autoplay controls preload="auto">
              <source :src="src" type="video/mp4" />
            </video>
            <a
              v-if="link"
              :href="link"
              target="_blank"
              rel="noopener"
              class="flex items-center justify-center w-full px-6 py-3 text-base font-medium leading-6 text-black transition duration-150 ease-in-out border border-transparent rounded-b-md bg-cta-default focus:outline-none"
              @click="sendGaEvent('cta-clicked')"
            >
              {{ label }}
            </a>
          </div>
        </div>
      </transition>
      <button
        v-show="!is_shown"
        @click="toggleVideo"
        class="relative w-24 h-24 overflow-hidden text-white transition-transform duration-150 transform border-4 rounded-full shadow-md hover:scale-110 lg:h-32 lg:w-32 lg:border-8 border-cta-default"
      >
        <div class="absolute inset-0 z-10 w-full bg-black opacity-25"></div>
        <span class="relative z-10 text-sm font-medium inset lg:text-base"
          >Talk to me!</span
        >
        <video
          class="absolute inset-0 object-fill w-full"
          autoplay
          muted
          loop
          preload="metadata"
        >
          <source :src="src" type="video/mp4" />
        </video>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: String,
    link: String,
    label: String
  },
  data() {
    return {
      is_shown: false
    };
  },
  methods: {
    toggleVideo() {
      this.is_shown = !this.is_shown;
      if (this.is_shown === true) {
        this.sendGaEvent("open-widget");
      } else {
        this.sendGaEvent("close-widget");
      }
    },
    sendGaEvent(name) {
      if (window.ga && typeof window.ga === "function") {
        window.ga("send", "event", "CCVideoWidget", name);
      }
    }
  }
};
</script>

<style scoped src="../main.css"></style>

<style scoped>
.bg-cta-default {
  background-color: #ffef29;
}

.border-cta-default {
  border-color: #ffef29;
}
</style>
